import { render, staticRenderFns } from "./MindoLiked.vue?vue&type=template&id=5e020bbb&"
import script from "./MindoLiked.vue?vue&type=script&lang=js&"
export * from "./MindoLiked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports